const APIClusterRequest = {};

// GET

APIClusterRequest["getAllClustersBySiteId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/clusters/site/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["getAllFarmersNotInClusterById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/farmers/not-in-cluster/site/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["getClusterById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/clusters/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["getAllTargetCropsByClusterId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/clusters/target-crop/cluster/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["getTargetCropById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/clusters/target-crop/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["getAllTargetCropStatus"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/target-crop-status', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["getAllUnitsOfMeasurement"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/unit-of-measurement', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["getAllCommitmentAndMarketingByTargetCropId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/clusters/commitment-and-marketing/target-crop/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["getAllCommitmentAndMarketingById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/clusters/commitment-and-marketing/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["getAllTargetCropByClusterIdAndCropId"] = async (accessToken, clid, crid) => {
	try {
		const response = await fetch('/api/clusters/target-crop/cluster/' + clid + '/crop/' + crid, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["getAllClustersBySiteIdAndCropId"] = async (accessToken, sid, cid) => {
	try {
		const response = await fetch(`/api/clusters/target-crop/site/${sid}/crop/${cid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

// POST

APIClusterRequest["addCluster"] = async (accessToken, data) => {
	try {
		const response = await fetch('/api/clusters', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["addClusterTargetCrop"] = async (accessToken, data) => {
	try {
		const response = await fetch('/api/clusters/target-crop', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["addCommitmentAndMarketingByTargetCropId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/clusters/commitment-and-marketing/target-crop/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

// PUT

APIClusterRequest["addClusterAETrackingStepOne"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-1/cluster/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["addClusterAETrackingStepTwo"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-2/cluster/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["addClusterAETrackingStepThree"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-3/cluster/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["addClusterAETrackingStepFour"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-4/cluster/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["addClusterAETrackingStepFive"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-5/cluster/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["addClusterAETrackingStepSix"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-6/cluster/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["addClusterAETrackingStepSeven"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-7/cluster/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["addClusterAETrackingStepEight"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-8/cluster/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

// PATCH

APIClusterRequest["editCluster"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/clusters/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["editClusterTargetCropById"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/clusters/target-crop/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["editCommitmentAndMarketingByTargetCropId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/clusters/commitment-and-marketing/target-crop/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["editClusterAETrackingStepOne"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-1/cluster/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["editClusterAETrackingStepTwo"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-2/cluster/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["editClusterAETrackingStepThree"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-3/cluster/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["editClusterAETrackingStepFour"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-4/cluster/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["editClusterAETrackingStepFive"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-5/cluster/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["editClusterAETrackingStepSix"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-6/cluster/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["editClusterAETrackingStepSeven"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-7/cluster/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["editClusterAETrackingStepEight"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/ae-tracking-step-8/cluster/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

// DELETE

APIClusterRequest["deleteClusterById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/clusters/' + id, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIClusterRequest["deleteTargetCropById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/clusters/target-crop/' + id, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}
export default APIClusterRequest
